(function () {

  function initQuiz(root) {

    if (!root || root.dataset.quizReady === 'true') return;

    root.dataset.quizReady = 'true';

    const quizShell = root.querySelector('.pfs__quiz-shell');
    const steps = Array.from(root.querySelectorAll('.pfs__step'));
    const result = root.querySelector('[data-result]');
    const progress = root.querySelector('[data-pfs-progress]');
    const currentLabel = root.querySelector('[data-pfs-current]');

    if (!quizShell || !steps.length || !result) return;

    let current = 0;

    let stoneData = {};

const stoneDataElement = root.querySelector('[data-pfs-stone-data]');

if (stoneDataElement) {
  try {
    stoneData = JSON.parse(stoneDataElement.textContent);
  } catch (error) {
    console.warn('Periana stone data could not be read:', error);
  }
}


    function showStep(index) {

      current = index;

      steps.forEach((step, i) => {
        step.classList.toggle('is-active', i === index);
      });

      if (progress) {
        progress.style.width =
          (((index + 1) / steps.length) * 100) + '%';
      }

      if (currentLabel) {
        currentLabel.textContent =
          String(index + 1).padStart(2, '0');
      }

      const error =
        steps[index].querySelector('.pfs__error');

      if (error) {
        error.classList.remove('is-visible');
      }

    }


    function validate(step) {

      const chosen =
        step.querySelector('input[type="radio"]:checked');

      const error =
        step.querySelector('.pfs__error');

      if (!chosen) {

        if (error) {
          error.classList.add('is-visible');
        }

        return false;
      }

      if (error) {
        error.classList.remove('is-visible');
      }

      return true;
    }


    function calculateScores() {

      const totals = {
        onyx: 0,
        moonstone: 0,
        rose: 0,
        morganite: 0,
        labradorite: 0,
        tourmaline: 0,
        ruby: 0
      };

      root
        .querySelectorAll('.pfs__step input[type="radio"]:checked')
        .forEach(input => {

          const scoreString =
            input.dataset.score || '';

          if (!scoreString) return;

          scoreString.split(',').forEach(entry => {

            const parts = entry.split(':');

            if (parts.length !== 2) return;

            const stone = parts[0];
            const value = Number(parts[1]);

            if (
              Object.prototype.hasOwnProperty.call(totals, stone) &&
              !Number.isNaN(value)
            ) {
              totals[stone] += value;
            }

          });

        });

      return Object.entries(totals)
        .sort((a, b) => b[1] - a[1]);
    }


    function showProducts(stoneKey) {

      const products =
        Array.from(root.querySelectorAll('.pfs-product'));

      const empty =
        root.querySelector('[data-products-empty]');

      let visibleCount = 0;

      products.forEach(product => {

        const match =
          product.dataset.productStone === stoneKey;

        product.classList.toggle('is-visible', match);

        if (match) visibleCount++;

      });

      if (empty) {
        empty.classList.toggle(
          'is-visible',
          visibleCount === 0
        );
      }

    }


    function renderResult() {

      const ranking = calculateScores();

      if (!ranking.length) return;

      const primaryKey = ranking[0][0];
      const secondaryKey = ranking[1][0];

      const primary = stoneData[primaryKey];
      const secondary = stoneData[secondaryKey];

      if (!primary || !secondary) return;


      const title =
        root.querySelector('[data-result-title]');

      const keywords =
        root.querySelector('[data-result-keywords]');

      const copy =
        root.querySelector('[data-result-copy]');

      const secondaryEl =
        root.querySelector('[data-secondary]');

      const imageHolder =
        root.querySelector('[data-result-image]');


      if (title) {
        title.textContent = primary.name;
      }

      if (keywords) {
        keywords.textContent = primary.keywords;
      }

      if (copy) {
        copy.innerHTML = primary.copy;
      }

      if (secondaryEl) {
        secondaryEl.textContent = secondary.name;
      }


      if (imageHolder) {

        if (primary.image) {

          const img = document.createElement('img');

          img.src = primary.image;
          img.alt = primary.name;

          imageHolder.innerHTML = '';
          imageHolder.appendChild(img);

        } else {

          imageHolder.innerHTML = '';

        }

      }


      showProducts(primaryKey);

      quizShell.style.display = 'none';

      result.classList.add('is-visible');

      root.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }


    root
      .querySelectorAll('.pfs__next')
      .forEach(button => {

        button.addEventListener('click', function () {

          const step = steps[current];

          if (!validate(step)) return;

          if (
            button.hasAttribute('data-find-result')
          ) {

            renderResult();

          } else if (
            current < steps.length - 1
          ) {

            showStep(current + 1);

          }

        });

      });


    root
      .querySelectorAll('.pfs__back')
      .forEach(button => {

        button.addEventListener('click', function () {

          if (current > 0) {
            showStep(current - 1);
          }

        });

      });


    const restart =
      root.querySelector('[data-restart]');

    if (restart) {

      restart.addEventListener('click', function () {

        root
          .querySelectorAll(
            '.pfs__step input[type="radio"]'
          )
          .forEach(input => {
            input.checked = false;
          });

        root
          .querySelectorAll('.pfs-product')
          .forEach(product => {
            product.classList.remove('is-visible');
          });

        result.classList.remove('is-visible');

        quizShell.style.display = '';

        showStep(0);

        root.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });

      });

    }

    showStep(0);
  }


  function initAll() {

    document
      .querySelectorAll('[data-pfs]')
      .forEach(initQuiz);

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  document.addEventListener(
    'shopify:section:load',
    function (event) {

      const section =
        event.target.querySelector('[data-pfs]');

      if (section) {

        section.dataset.quizReady = 'false';

        initQuiz(section);

      }

    }
  );

})();